module.exports = __webpack_public_path__ + "img/it-reference-03.026f5bb4.webp";